import React, { useEffect, useState } from "react";
import { useForm } from 'react-hook-form';
import MaterialTable from 'material-table';
import Select from 'react-select'

// reactstrap components
import { Button, Card, CardHeader, CardBody, FormGroup, Form, Input, Row, Col, Container } from "reactstrap";

// style
import "assets/css/loading.css";
import { table_translate, table_style } from "constants/MaterialTable.js";

// services
import { InputCEP, InputCNPJ, InputTELEFONE } from "services/mask.js";
import { showMessage, showQuestion } from "services/message.js";
import { api_GET, api_POST } from "services/api_service.js";
import { getSessionCookie } from "services/session.js";
import { EnviaProtocoloTransportadorLocalDestino, EnviaRequerimentoTransportadorLocalDestino } from "services/protocolo_transportador_service.js";
import { GetCEPViaCEP } from "services/viaCep";

export default function LocaisDestinacao({ item, tipoCadastro, permiteManutencao, handleProximoStep, handleStepAnterior }) {

    const { register, handleSubmit, errors, setError, setValue, clearErrors, reset } = useForm({ mode: "onBlur" });
    let session = getSessionCookie();

    const [showLoading, setshowLoading] = React.useState(false);

    const [registro, set_registro] = React.useState(null);
    const [locais_destinacao, set_locais_destinacao] = React.useState([]);
    const [cnpj, set_cnpj] = React.useState("");
    const [telefone, set_telefone] = React.useState("");
    const [celular, set_celular] = React.useState("");

    useEffect(() => {
        if (tipoCadastro == "Protocolo")
            loadItemProtocolo();
        else if (tipoCadastro == "Requerimento")
            loadItemRequerimento();
    }, []);
    const loadItemProtocolo = () => {
        set_registro(item);
        if (item != null && item.protocoloTransportador[0].protocoloTransportadorLocalDestino != null) {
            set_locais_destinacao(item.protocoloTransportador[0].protocoloTransportadorLocalDestino);
        }
    }
    const loadItemRequerimento = () => {
        set_registro(item);
        if (item != null && item.requerimentoTransportadorLocalDestino != null) {
            set_locais_destinacao(item.requerimentoTransportadorLocalDestino);
        }

        if (tipoCadastro == "Requerimento") {
            let _action = actions;
            _action.push({
                icon: 'delete',
                tooltip: 'Remover Local',
                onClick: (event, rowData) => handleRemove(rowData)
            });

            set_actions(_action);
        }
    }

    // Material-Table > Actions
    const [actions, set_actions] = useState([
        {
            icon: 'edit',
            tooltip: 'Editar Registro',
            onClick: (event, rowData) => handleEdit(rowData)
        }
    ]);

    // CEP
    const [cep, set_cep] = React.useState("");
    const [editarEndereco, set_editarEndereco] = useState(true);
    const handleCEP = (event) => {
        set_cep(event.target.value);

        if (event.target.value.replaceAll("_", "").length != 9)
            return;

        clearErrors("cep");

        GetCEPViaCEP(event.target.value).then(result => {
            if (result.status !== 200 || (result.data.hasOwnProperty('erro') && result.data.erro == true)) {
                showMessage("Aviso", "Cep não localizado", 'warning', null);
                setValue("logradouro", "");
                setValue("bairro", "");
                setValue("cidade", "");
                setValue("uf", "");
                set_editarEndereco(true);
            }
            else {
                setValue("logradouro", result.data.logradouro);
                setValue("bairro", result.data.bairro);
                setValue("cidade", result.data.localidade);
                setValue("uf", result.data.uf);

                if (result.data.logradouro == null || result.data.logradouro.length == 0)
                    set_editarEndereco(false);
                else
                    set_editarEndereco(true);
            }
        });
    }

    // Status
    const [status, set_status] = React.useState("");
    const [options_status] = React.useState([
        { value: "Ativo", label: "Ativo" },
        { value: "Inativo", label: "Inativo" },
    ]);
    const handleStatus = (value) => {
        set_status(value);
        setValue("status", value, true);
        clearErrors("status");
    }

    const [rowEdit, set_rowEdit] = React.useState(null);
    const handleEdit = (rowData) => {
        set_rowEdit(rowData);
        set_cnpj(rowData.cnpj);
        setValue("cnpj", rowData.cnpj);
        setValue("fantasia", rowData.fantasia);
        setValue("razaoSocial", rowData.razaoSocial);
        setValue("telefone", rowData.telefone);
        set_telefone(rowData.telefone);
        setValue("celular", rowData.celular);
        set_celular(rowData.celular);

        set_cep(rowData.cep);
        setValue("cep", rowData.cep);
        setValue("logradouro", rowData.logradouro);
        setValue("numEndereco", rowData.numEndereco);
        setValue("complemento", rowData.complemento);
        setValue("bairro", rowData.bairro);
        setValue("cidade", rowData.cidade);
        setValue("uf", rowData.uf);
        set_status(rowData.status);
        setValue("status", rowData.status, true);
    }

    const handleRemove = (rowData) => {
        if (!permiteManutencao && tipoCadastro == "Protocolo") {
            showMessage("Aviso", "Não permitida a manutenção do cadastro.", 'error', null);
            return;
        }

        showQuestion('Atenção', 'Deseja remover este local?', 'question', function (result) {
            if (result) {
                setshowLoading(true);
                let _usuarioId = session != null ? session.usuario_Id : 0;

                if (tipoCadastro == "Protocolo") {
                    api_POST('protocoloTransportador/PostRemoveLocalDestinoProtocolo/' + _usuarioId + "/" + rowData.protocoloTransportadorLocalDestino_Id).then(result => {
                        setshowLoading(false);
                        if (result.status !== 200)
                            showMessage("Aviso", result.message, 'error', null);
                        else {
                            showMessage("Aviso", "Local removido com sucesso!", 'success', function () {
                                handleReturnRemove(rowData.protocoloTransportador_Id);
                            });
                        }
                    });
                }
                else {
                    api_POST('requerimentoTransportador/PostRemoverLocalDestinoRequerimento/' + rowData.requerimentoTransportadorLocalDestino_Id).then(result => {
                        setshowLoading(false);
                        if (result.status !== 200)
                            showMessage("Aviso", result.message, 'error', null);
                        else {
                            showMessage("Aviso", "Local removido com sucesso!", 'success', function () {
                                handleReturnRemove(rowData.requerimento_Id);
                            });
                        }
                    });
                }
            }
        })
    }
    const handleReturnRemove = (reloadId) => {
        setshowLoading(true);

        if (tipoCadastro == "Protocolo") {
            api_GET('protocoloTransportador/GetLocaisDestinoProtocolo/' + reloadId).then(result => {
                setshowLoading(false);
                if (result.status !== 200) {
                    showMessage("Aviso", result.message, 'error', null);
                }
                else {
                    set_locais_destinacao(result.data);
                }
            });
        }
        else {
            api_GET('requerimentoTransportador/GetLocaisDestinoRequerimento/' + reloadId).then(result => {
                setshowLoading(false);
                if (result.status !== 200) {
                    showMessage("Aviso", result.message, 'error', null);
                }
                else {
                    set_locais_destinacao(result.data);
                }
            });
        }
    }

    const onSubmit = (data) => {
        if (rowEdit == null && locais_destinacao.filter(f => f.cnpj == cnpj).length > 0) {
            showMessage("Aviso", "Já existe um local de destinação com este CNPJ!", 'error', null);
            return;
        }

        if (rowEdit == null && locais_destinacao.filter(f => f.cEP == data.cep && f.numEndereco == data.numEndereco).length > 0) {
            showMessage("Aviso", "Já existe um local de destinação neste endereço!", 'error', null);
            return;
        }

        setshowLoading(true);
        if (permiteManutencao && tipoCadastro == "Protocolo") {
            let json = carregaJsonProtocolo(data);
            EnviaProtocoloTransportadorLocalDestino(json, confirmaAddLocaisDestino)
        }
        else if (tipoCadastro == "Requerimento") {
            let json = carregaJsonRequerimento(data);
            EnviaRequerimentoTransportadorLocalDestino(json, confirmaAddLocaisDestino)
        }
    }
    const carregaJsonProtocolo = (data) => {
        let json_submit = {
            protocoloTransportadorLocalDestino_Id: rowEdit == null ? 0 : rowEdit.protocoloTransportadorLocalDestino_Id,
            protocoloTransportador_Id: item.protocoloTransportador[0].protocoloTransportador_Id,
            cnpj: cnpj.replace(/[./-]/g, ''),
            fantasia: data.fantasia,
            razaoSocial: data.razaoSocial,
            telefone: telefone.replaceAll("(", "").replaceAll(")", "").replaceAll("-", "").replaceAll(" ", ""),
            celular: celular.replaceAll("(", "").replaceAll(")", "").replaceAll("-", "").replaceAll(" ", ""),
            cEP: data.cep.replace(/[^0-9]/g,''),
            logradouro: data.logradouro,
            numEndereco: data.numEndereco,
            complemento: data.complemento,
            bairro: data.bairro,
            cidade: data.cidade,
            uf: data.uf,
            status: status != "" ? status : "Ativo",
            usuarioUltimaAlteracao_Id: session != null ? session.usuario_Id : null
        }
        return json_submit;
    }
    const carregaJsonRequerimento = (data) => {
        let json_submit = {
            requerimentoTransportadorLocalDestino_Id: rowEdit == null ? 0 : rowEdit.requerimentoTransportadorLocalDestino_Id,
            requerimento_Id: item.requerimento_Id,
            cnpj: cnpj.replace(/[./-]/g, ''),
            fantasia: data.fantasia,
            razaoSocial: data.razaoSocial,
            telefone: telefone.replaceAll("(", "").replaceAll(")", "").replaceAll("-", "").replaceAll(" ", ""),
            celular: celular.replaceAll("(", "").replaceAll(")", "").replaceAll("-", "").replaceAll(" ", ""),
            cEP: data.cep.replace(/[^0-9]/g,''),
            logradouro: data.logradouro,
            numEndereco: data.numEndereco,
            complemento: data.complemento,
            bairro: data.bairro,
            cidade: data.cidade,
            uf: data.uf,
            status: "Ativo",
            usuarioUltimaAlteracao_Id: session != null ? session.usuario_Id : null
        }
        return json_submit;
    }
    const confirmaAddLocaisDestino = (result) => {
        setshowLoading(false);
        if (result.status !== 200) {
            showMessage("Aviso", result.message, 'error', null);
            return;
        }

        let local = result.data;

        let new_list = [];

        let _registro = registro;
        if (tipoCadastro == "Protocolo") {
            locais_destinacao.map(m => {
                if (m.protocoloTransportadorLocalDestino_Id != local.protocoloTransportadorLocalDestino_Id)
                    new_list.push(m);
            });
            _registro.protocoloTransportador[0].protocoloTransportadorLocalDestino = new_list;
        }
        else if (tipoCadastro == "Requerimento") {
            locais_destinacao.map(m => {
                if (m.requerimentoTransportadorLocalDestino_Id != local.requerimentoTransportadorLocalDestino_Id)
                    new_list.push(m);
            });
            _registro.requerimentoTransportador[0].requerimentoTransportadorLocalDestino = new_list;
        }

        new_list.push(local);
        set_locais_destinacao(new_list);
        set_registro(_registro);

        set_cnpj("");
        setValue("cnpj", "");
        setValue("fantasia", "");
        setValue("razaoSocial", "");
        setValue("telefone", "");
        set_telefone("");
        setValue("celular", "");
        set_celular("");
        set_cep("");
        setValue("cep", "");
        setValue("logradouro", "");
        setValue("numEndereco", "");
        setValue("complemento", "");
        setValue("bairro", "");
        setValue("cidade", "");
        setValue("uf", "");
        set_status("");
        setValue("status", "", false);

        set_rowEdit(null);

        showMessage("Aviso", "Operação executada com sucesso", 'success', null);
    }

    const handleAvancar = () => {
        if (session == null && locais_destinacao.length == 0) {
            showMessage("Aviso", "Você não pode avançar sem informar os locais de destino", 'error', null);
            return;
        }
        handleProximoStep(registro);
    }

    return (
        <>
            {showLoading &&
                <div className="carregandoCmp">
                    <div className="box">
                        <img src={require("assets/img/loading.gif")}></img>
                    </div>
                </div>
            }
            <div>
                <Card className={`card card-stats`}>
                    <CardHeader>
                        <Row><Col md="12" className="text-right"><label className="text-danger">* Campos Obrigatórios</label></Col></Row>
                    </CardHeader>
                    <CardBody>
                        <Container style={{ maxWidth: "1000px", margin: "20px auto" }}>
                            <h2 className="titulo-solicitacao">Locais de Destinação</h2>
                            <div className="formPrincipal">
                                <Form onSubmit={handleSubmit(onSubmit)}>
                                    <Row>
                                        <h4 style={{ borderBottom: "solid 1px #ccc", width: "100%" }}>Empresa</h4>
                                        <Col md="6" lg="6">
                                            <FormGroup>
                                                <b><label><span className="text-danger">*</span> Nome Fantasia</label></b>
                                                <Input type="text" name="fantasia" maxLength="100" innerRef={register({ required: true })} />
                                                {errors.fantasia && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                                            </FormGroup>
                                        </Col>
                                        <Col md="6" lg="6">
                                            <FormGroup>
                                                <b><label><span className="text-danger">*</span> Razão Social</label></b>
                                                <Input type="text" name="razaoSocial" maxLength="100" innerRef={register({ required: true })} />
                                                {errors.razaoSocial && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                                            </FormGroup>
                                        </Col>
                                        <Col md="3" lg="3">
                                            <FormGroup>
                                                <b><label><span className="text-danger">*</span> CNPJ</label></b>
                                                <InputCNPJ name="cpf_cnpj" onChange={(event) => set_cnpj(event.target.value)} value={cnpj} inputRef={register({ required: true })} />
                                                {errors.cpf_cnpj && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                                            </FormGroup>
                                        </Col>
                                        <Col md="3" lg="3">
                                            <FormGroup>
                                                <b><label>Telefone</label></b>
                                                <InputTELEFONE type="text" name="telefone" onChange={(event) => set_telefone(event.target.value)} value={telefone} inputRef={register({ required: false })} />
                                            </FormGroup>
                                        </Col>
                                        <Col md="3" lg="3">
                                            <FormGroup>
                                                <b><label>Celular</label></b>
                                                <InputTELEFONE type="text" name="celular" onChange={(event) => set_celular(event.target.value)} value={celular} inputRef={register({ required: false })} />
                                            </FormGroup>
                                        </Col>
                                        <Col md="3" lg="3">
                                            <FormGroup>
                                                <b><label><span className="text-danger">*</span> Status</label></b>
                                                <Select
                                                    options={options_status}
                                                    name="status"
                                                    onChange={(e) => { handleStatus(e.value) }}
                                                    getOptionLabel={({ label }) => label}
                                                    getOptionValue={({ value }) => value}
                                                    value={status != "" && options_status.find(obj => obj.value === status)}
                                                    placeholder="Selecione"
                                                    ref={e => register(
                                                        { name: "status" },
                                                        { required: true })
                                                    }
                                                />
                                                {errors.status && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                                            </FormGroup>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <h4 style={{ borderBottom: "solid 1px #ccc", width: "100%" }}>Endereço</h4>
                                        <Col md="3" lg="3">
                                            <FormGroup>
                                                <b><label><span className="text-danger">*</span> CEP</label></b>
                                                <InputCEP name="cep" onChange={handleCEP} value={cep} inputRef={register({ required: true })} />
                                                {errors.cep && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                                            </FormGroup>
                                        </Col>
                                        <Col md="5" lg="5">
                                            <FormGroup>
                                                <b><label><span className="text-danger">*</span> Logradouro</label></b>
                                                <Input type="text" name="logradouro" readOnly={editarEndereco} maxLength="100" innerRef={register({ required: true })} />
                                                {errors.logradouro && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                                            </FormGroup>
                                        </Col>
                                        <Col md="4" lg="4">
                                            <FormGroup>
                                                <b><label><span className="text-danger">*</span> Bairro</label></b>
                                                <Input type="text" name="bairro" readOnly={editarEndereco} maxLength="50" innerRef={register({ required: true })} />
                                                {errors.bairro && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                                            </FormGroup>
                                        </Col>
                                        <Col md="2" lg="2">
                                            <FormGroup>
                                                <b><label><span className="text-danger">*</span> Número</label></b>
                                                <Input type="number" name="numEndereco" maxLength="10" innerRef={register({ required: true })} />
                                                {errors.numEndereco && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                                            </FormGroup>
                                        </Col>
                                        <Col md="3" lg="3">
                                            <FormGroup>
                                                <b><label>Complemento</label></b>
                                                <Input type="text" name="complemento" maxLength="50" innerRef={register({ required: false })} />
                                            </FormGroup>
                                        </Col>
                                        <Col md="4" lg="4">
                                            <FormGroup>
                                                <b><label><span className="text-danger">*</span> Cidade</label></b>
                                                <Input type="text" name="cidade" readonly="readonly" maxLength="50" innerRef={register({ required: true })} />
                                                {errors.cidade && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                                            </FormGroup>
                                        </Col>
                                        <Col md="1" lg="1">
                                            <FormGroup>
                                                <b><label><span className="text-danger">*</span> UF</label></b>
                                                <Input type="text" name="uf" readonly="readonly" innerRef={register({ required: true })} />
                                                {errors.uf && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                                            </FormGroup>
                                        </Col>
                                        <Col md="12" lg="12" className="text-center">
                                            <FormGroup>
                                                <Button color="success" className="btn-mobile" type="submit">  <i className="fas fa-save"></i> Salvar Local</Button>
                                            </FormGroup>
                                        </Col>
                                    </Row>
                                </Form>
                            </div>
                            <Row>
                                <Col md="12">
                                    {showLoading &&
                                        <div className="carregandoCmp">
                                            <div className="box">
                                                <img src={require("assets/img/loading.gif")}></img>
                                            </div>
                                        </div>
                                    }
                                    <MaterialTable style={{ minHeight: "auto" }}
                                        title=""
                                        columns={[
                                            { title: 'CNPJ', field: 'cnpj' },
                                            { title: 'Fantasia', field: 'fantasia' },
                                            { title: 'Logradouro', field: 'logradouro' },
                                            { title: 'Bairro', field: 'Bairro' },
                                            { title: 'Número', field: 'numEndereco' },
                                            { title: 'Complemento', field: 'Bairro' },
                                            { title: 'Status', field: 'status' }
                                        ]}
                                        data={locais_destinacao}
                                        isLoading={false}
                                        actions={actions}
                                        localization={table_translate}
                                        options={table_style}
                                    />
                                </Col>
                                <Col lg="6" className="text-left">
                                    <Button color="secundary" onClick={() => handleStepAnterior(registro)} className="btn-mobile" type="submit"><i className="fas fa-chevron-left"></i> Voltar</Button>
                                </Col>
                                <Col lg="6" className="text-right">
                                    <Button color="success" onClick={handleAvancar} className="btn-mobile" type="button">Próxima Etapa  <i className="fas fa-chevron-right"></i></Button>
                                </Col>
                            </Row>
                        </Container>
                    </CardBody>
                </Card>
            </div>
        </>
    );
}